module.exports = __webpack_public_path__ + "static/img/20d.dcede9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/20d.jpg
// module id = mGRQ
// module chunks = 0